import { Component, inject, input } from '@angular/core';
import { ParagraphPgPs } from '@app/models/paragraph.model';
import { NodeAward, NodeProcom, NodeProduct } from '@app/models/entity.model';
import { SectionTitleComponent } from '@app/components/section-title/section-title.component';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';

import { CardComponent } from '@app/components/card/card.component';
import { MobiUiCarouselComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { TextComponent } from '@app/components/text/text.component';
import { MediaComponent } from '@app/components/media/media.component';
import { BreakpointService } from '@app/services/breakpoint.service';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { ProductRelationComponent } from '@app/components/product/product-relation/product-relation.component';
import { ProductAwardComponent } from '@app/components/product/product-award/product-award.component';
import { Media } from '@app/models/media.model';

@Component({
  selector: 'mobi-product-in-short',
  templateUrl: './product-in-short.component.html',
  styleUrls: ['./product-in-short.component.scss'],
  imports: [
    ComponentSharedModule,
    SectionTitleComponent,
    ContentSectionComponent,
    CardComponent,
    TextComponent,
    MediaComponent,
    MobiUiCarouselComponent,
    ProductRelationComponent,
    ProductAwardComponent,
  ],
  standalone: true,
  host: {
    style: 'display: contents',
  },
})
export class ProductInShortComponent {
  readonly inShortTitle = input.required<string>();
  readonly inShortSubtitle = input<string | undefined>('');
  readonly inShortText = input<string | undefined>('');
  readonly advantages = input<ParagraphPgPs[]>();
  readonly productAward = input<NodeAward>();
  readonly comboProduct = input<NodeProcom>();
  readonly productTitle = input<string | undefined>('');
  readonly products = input<NodeProduct[]>();
  readonly productsTitle = input<string | undefined>('');
  readonly comboProductSectionTitle = input<string | undefined>('');
  readonly anchorId = input<string | undefined>('');
  readonly video = input<Media>();
  readonly hideRelation = input(false);

  breakpoint = inject(BreakpointService);
}
